import { RMovimentoDto, RMovimentoRecebidoDto } from "@/api.types";

export interface GrupoPorLocal {
  nome: string;
  defensor: string;
  recebimentos: RMovimentoRecebidoDto[];
}

export function agruparPorDefensoriaNucleo(dados: RMovimentoDto[]): GrupoPorLocal[] {
  const agrupado: Record<string, { defensor: string, recebimentos: RMovimentoRecebidoDto[] }> = {};

  dados.forEach(itemDefensor => {
    itemDefensor.recebimentos.forEach(recebimento => {
      const chave = recebimento.nucleo ? recebimento.nucleo : recebimento.defensoria;

      if (!agrupado[chave]) {
        agrupado[chave] = {
          defensor: itemDefensor.defensor,
          recebimentos: []
        };
      }
      agrupado[chave].recebimentos.push(recebimento);
    });
  });

  return Object.keys(agrupado).map(chave => ({
    nome: chave,
    defensor: agrupado[chave].defensor,
    recebimentos: agrupado[chave].recebimentos,
  }));
}